
<script>
  import store from '../../../store/';
  import { LiveWorker } from "../../../workers";
  import liveNow from '../live-now/live-now-widget';
  export default {
    name: 'LiveFavoritesWidget',
    extends: liveNow,
    props: {
      showTeamIcon: {
        type: Boolean,
        default: false,
        label: 'show team icon',
      },
      titleLive: {
        type: String,
        default: 'W.LiveFavorites',
        label: 'Live Title',
        excluded: true,
      },
      isFavorites: {
        type: Boolean,
        default: true,
        excluded: true,
      }
    },
    created() {
      this.dispatch();
      if (!this.matches.length && APP_SETTINGS.settings.layout !== "US") {
        LiveWorker.postMessage({ ev: 'lSportMatches', resp: {} });
      }
      LiveWorker.addEventListener('message', this.totalLiveMatches);
      if (APP_SETTINGS.settings.layout === "US") {
        LiveWorker.postMessage({ ev: 'allLiveMatches', resp: {} });
      }
    },
    beforeDestroy() {
      LiveWorker.removeEventListener('message', this.totalLiveMatches);
    },
    watch: {
      favoriteSportIds(curr, prev) {
        if (curr.length !== prev.length) {
          this.sportId = 0;
        }
        this.setSports();
      },
      favoriteMatchesIds() {
        this.filterFavorites();
      }
    },
    computed: {
      favoriteSportIds() {
        return store.getters.liveFavoriteSportIds;
      },
      favoriteMatchesIds() {
        return store.getters.getFavoritesBetRadarMatchIds;
      },
    },
    methods: {
      // set  the list of favorites sports
      setSports(allSports = null) {
        if (allSports) {
          this.allLiveSportIds = this.favoriteSportIds.filter(sid => allSports.includes(`${sid}`));
        } else {
          this.allLiveSportIds = this.favoriteSportIds;
        }
        if (!this.sportId) {
          const sportId = this.allLiveSportIds.length ? Number.parseInt(this.allLiveSportIds[0], 10) : 0;
          this.setSport(sportId);
        }
      },
      // filter the live matches to show only the favorites
      filterFavorites(allEvents = null) {
        const ae = allEvents || this.matches;
        this.matches = [];
        this.favoriteMatchesIds.forEach((brid) => {
          const filteredMatch = ae.find(m => `${m.betRadarId}` === `${brid}`);
          if (filteredMatch) {
            this.matches.push(filteredMatch);
          }
        });
        if (!this.matches.length) {
          this.showNoMatchesMsg = true;
        }
      },
      filterBySport(msg) {
        if (APP_SETTINGS.settings.layout !== "US") {
          this.markets = msg.data.data.mr;
          this.filterFavorites(msg.data.data.lm);
        }
      },
      filterAllMatches(msg) {
        if (APP_SETTINGS.settings.layout === 'US') {
          this.filterFavorites(msg.data.data.lm);
        }
      },
      totalLiveMatches(msg) {
        switch (msg.data.type) {
          case "sportIds":
            this.setSports(msg.data.data);
            break;
          case "matches":
            this.filterBySport(msg);
            break;
          case "allLiveMatches":
            this.filterAllMatches(msg);
            break;
        }
      },
      dispatch() {
        store.dispatch('cleanOldFavorites');
      },
    },
  };
</script>
